"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMenuItem = exports.StyledMenuItemChildrenWrapper = exports.StyledMenuItemIconWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../../helpers");
const StackView_1 = require("../../../StackView");
const View_1 = require("../../../View");
exports.StyledMenuItemIconWrapper = (0, styled_components_1.default)(View_1.View) `
    flex-shrink: 0;
    width: ${helpers_1.SPACING_M};
    height: ${helpers_1.SPACING_M};
`;
exports.StyledMenuItemChildrenWrapper = styled_components_1.default.div `
    flex-grow: 1;
    min-width: 0;
    height: ${helpers_1.SPACING_XL};
    text-overflow: ellipsis;
    overflow: hidden;
`;
exports.StyledMenuItem = (0, styled_components_1.default)(StackView_1.StackView) `
    display: flex;
    align-items: center;
    padding: 0 ${({ hasSubmenu }) => (hasSubmenu ? helpers_1.SPACING_S : helpers_1.SPACING_M)} 0 ${helpers_1.SPACING_M};
    height: ${helpers_1.SPACING_XL};

    font-size: ${helpers_1.FONT_SIZE_M};
    font-family: ${helpers_1.BASE_FONT_FAMILY};
    line-height: ${helpers_1.SPACING_XL};
    font-weight: ${helpers_1.BASE_FONT_NORMAL_WEIGHT};

    background-color: #ffffff;

    ${({ disabled, theme }) => disabled
    ? (0, styled_components_1.css) `
                  color: ${theme.colorTextLight};
                  cursor: default;
              `
    : (0, styled_components_1.css) `
                  color: ${({ theme }) => theme.colorLink};
                  cursor: pointer;

                  &:hover {
                      background-color: ${({ theme }) => theme.colorHighlightLight};
                  }
                  &:active {
                      background-color: ${({ theme }) => theme.colorHighlightDark};
                  }
              `}

    ${({ isActive, disabled, theme }) => isActive &&
    !disabled &&
    (0, styled_components_1.css) `
            &,
            &:hover {
                background-color: ${theme.colorHighlightDark};
            }
        `}
`;
//# sourceMappingURL=MenuItem.styles.js.map